export function formatPlanLabel(plan?: string | null) {
  if (!plan || plan === 'free') return 'Free';

  const normalized = plan.toLowerCase();
  const map: Record<string, string> = {
    pro_plan: 'Pro',
    starter_plan: 'Starter',
    start_plan: 'Starter',
    startplan: 'Starter',
  };

  if (map[normalized]) return map[normalized];

  return plan
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
